<template>
  <v-card class="d-flex align-start item" color="transparent" flat tile>
    <v-sheet class="rounded-lg item-img-container">
      <img
        @error="onError"
        class="d-block"
        :src="files + img + '?resize=1&w=53'"
        :alt="title"
        width="53px"
      />
    </v-sheet>

    <div class="ml-5">
      <div
        class="text-body-1 text-md-subtitle-1 font-weight-bold"
        :class="{ 'white--text': dark, 'grey--text text--darken-4': !dark }"
      >
        {{ title }}
      </div>

      <div
        class="text-body-2 font-weight-regular mt-2"
        :class="{ 'white--text': dark, 'grey--text text--darken-4': !dark }"
      >
        {{ text }}
      </div>
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    img: {
      type: String,
      default: DefaultImg,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img-container {
    padding: 7px;
  }
}
</style>
